import styled from 'styled-components';

import { StatusBanner } from '@xing-com/banner';
import { spaceXL } from '@xing-com/tokens';

export const FormMessageBanner = styled(StatusBanner)`
  margin-bottom: ${spaceXL};
`;
